import React from 'react'
import CTA from '@f/elements/CTA/CTA'
import { getUrl } from '@js/common/getUrlByDomain'

function redirectToUserLogin() {
  window.location.href = `${getUrl('userAccount')()}anmelden/`
}

export const UserExistsMessage = () => {
  return (
    <div className='[ f-d-flc f-fl-al-ce ]'>
      <p className='[ f-p-a-020 f-t-tminor f-t-bold f-t-centre ]'>
        Es besteht bereits ein Konto mit dieser E-Mail-Adresse
      </p>
      <p className='[ f-t-paragraph f-t-centre f-m-a-0 f-m-b-040 ]'>
        Bitte melden Sie sich an, um das Haus Ihren Favoriten hinzuzufügen:
      </p>
      <CTA tag='button' type='block-primary' onClick={redirectToUserLogin}>
        Jetzt anmelden
      </CTA>
    </div>
  )
}
